import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../chronos-modal/nn-chronos-modal.js';
import '../../atoms/chronos-button/nn-chronos-button.js';

/**
 * Chronos card molecule. Used with Chronos modal molecule and chronos button atom.
 *
 * title - The title text.
 * subTitle - The subtitle text.
 */

@customElement('nn-chronos-card')
export class ChronosCard extends LitElement {
  static styles = css`
    .chronos-ctn {
      align-items: center;
      background-color: white;
      border: 2px solid var(--nn-chronos-card_chronos-ctn_border-color, #dbdbdb);
      border-radius: var(--nn-chronos-card_chronos-ctn_border-radius, 25px);
      display: flex;
      flex-direction: column;
      gap: var(--nn-chronos-card_chronos-ctn_gap, 16px);
      justify-content: center;
      padding: var(--nn-chronos-card_chronos-ctn_padding, 20px 40px 32px);
    }
    .chronos__text {
      font-family: 'font-medium';
      font-size: var(--nn-chronos-card_chronos__text-font-size, 1.1rem);
      margin: var(--nn-chronos-card_chronos__text-margin, 0);
      text-align: center;
    }
    .chronos__text--bolder b {
      font-family: 'font-heavy';
      font-weight: 400;
    }
    .chronos__button--img {
      fill: var(--nn-chronos-card_chronos__button--img_fill, #000);
    }
    .chrn__text {
      padding: var(--nn-chronos-card_chrn__text_padding, 40px);
      text-align: left;
    }
    .chrn__text--tiny-title {
      font-size: var(
        --nn-chronos-card_chrn__text--tiny-title_font-size,
        1.4rem
      );
      font-weight: 600;
    }
    .chrn__text--big-title {
      font-size: var(--nn-chronos-card_chrn__text--big-title_font-size, 2.2rem);
      font-weight: 900;
    }
  `;

  @property({ type: String }) title = "Vous avez besoin d'aide&nbsp;?";

  @property({ type: String }) subtitle =
    'Nos conseillers sont à votre disposition pour vous accompagner dans votre prise de commande.';

  render() {
    return html`
      <div class="chronos-ctn">
        <p class="chronos__text chronos__text--bolder">
          <b>${this.parseHtml(this.title)}</b>
        </p>
        <p class="chronos__text chronos__text--bold">
          ${this.parseHtml(this.subtitle)}
        </p>
        <slot name="modalOpener"></slot>
      </div>
    `;
  }

  // eslint-disable-next-line class-methods-use-this
  parseHtml(str?: any) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  }
}
